module.exports = __webpack_public_path__ + "static/media/255px_logo_bug_bl.d545b541.png";